export default "__VITE_ASSET__aI6V2iB3__"